/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Search_PlaceholderInputs */

const en_admin_payments_search_placeholder = /** @type {(inputs: Admin_Payments_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search order no or email...`)
};

const zh_admin_payments_search_placeholder = /** @type {(inputs: Admin_Payments_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索订单号或邮箱...`)
};

/**
* | output |
* | --- |
* | "Search order no or email..." |
*
* @param {Admin_Payments_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_search_placeholder = /** @type {((inputs?: Admin_Payments_Search_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Search_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_search_placeholder(inputs)
	return zh_admin_payments_search_placeholder(inputs)
});
export { admin_payments_search_placeholder as "admin.payments.search_placeholder" }